export default __webpack_public_path__ + "static/media/visitingcardnexus.52441e22.PNG";